import { render, staticRenderFns } from "./ModalOrderModule.vue?vue&type=template&id=7b8b28b5&"
import script from "./ModalOrderModule.vue?vue&type=script&lang=js&"
export * from "./ModalOrderModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports